import { render, staticRenderFns } from "./WaveyBackground.vue?vue&type=template&id=45162cf0&scoped=true"
import script from "./WaveyBackground.vue?vue&type=script&lang=js"
export * from "./WaveyBackground.vue?vue&type=script&lang=js"
import style0 from "./WaveyBackground.vue?vue&type=style&index=0&id=45162cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45162cf0",
  null
  
)

export default component.exports